import React from 'react';
import {ReviewNotes} from "./Desktop";

export default () => {

    return (
        <ReviewNotes/>
    );
};
